import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaImages, FaLayerGroup } from 'react-icons/fa';
import { getNeighborhoodDevelopments } from '../../api/neighborhoodService';

export const fallbackMahalleler = [
  { id: 1, name: 'Barbaros Mahallesi', image: '/assets/images/mahalleler/barbaros/1.jpg', urlTag: 'barbaros', totalImages: 5 },
  { id: 2, name: 'Cumhuriyet Mahallesi', image: '/assets/images/mahalleler/cumhuriyet/1.jpg', urlTag: 'cumhuriyet', totalImages: 2 },
  { id: 3, name: 'Denizciler Mahallesi', image: '/assets/images/mahalleler/denizciler/1.jpg', urlTag: 'denizciler', totalImages: 2 },
  { id: 4, name: 'Gültepe Mahallesi', image: '/assets/images/mahalleler/gultepe/1.jpg', urlTag: 'gultepe', totalImages: 14 },
  { id: 5, name: 'İsmet İnönü Mahallesi', image: '/assets/images/mahalleler/ismet-inonu/1.jpg', urlTag: 'ismet-inonu', totalImages: 1 },
  { id: 6, name: 'Akçay Mahallesi', image: '/assets/images/mahalleler/akcay/1.jpg', urlTag: 'akcay', totalImages: 1 },
  { id: 7, name: 'Azganlık Mahallesi', image: '/assets/images/mahalleler/azganlik/1.jpg', urlTag: 'azganlik', totalImages: 1 },
  { id: 8, name: 'Aşkarbeyli Mahallesi', image: '/assets/images/mahalleler/askarbeyli/1.jpg', urlTag: 'askarbeyli', totalImages: 1 },
  { id: 9, name: 'Bekbele Mahallesi', image: '/assets/images/mahalleler/bekbele/1.jpg', urlTag: 'bekbele', totalImages: 1 },
  { id: 10, name: 'Büyükdere Mahallesi', image: '/assets/images/mahalleler/buyukdere/1.jpg', urlTag: 'buyukdere', totalImages: 1 },
  { id: 11, name: 'Cebike Mahallesi', image: '/assets/images/mahalleler/cebike/1.jpg', urlTag: 'cebike', totalImages: 1 },
  { id: 12, name: 'Dumlupınar Mahallesi', image: '/assets/images/mahalleler/dumlupinar/1.jpg', urlTag: 'dumlupinar', totalImages: 1 },
  { id: 13, name: 'Esentepe Mahallesi', image: '/assets/images/mahalleler/esentepe/1.jpg', urlTag: 'esentepe', totalImages: 1 },
  { id: 14, name: 'Fatih Sultan Mehmet Mahallesi', image: '/assets/images/mahalleler/fatih-sultan-mehmet/1.jpg', urlTag: 'fatih-sultan-mehmet', totalImages: 1 },
  { id: 15, name: 'Gürsel Mahallesi', image: '/assets/images/mahalleler/gursel/1.jpg', urlTag: 'gursel', totalImages: 1 },
  { id: 16, name: 'Kocatepe Mahallesi', image: '/assets/images/mahalleler/kocatepe/1.jpg', urlTag: 'kocatepe', totalImages: 1 },
  { id: 17, name: 'Numune Mahallesi', image: '/assets/images/mahalleler/numune/1.jpg', urlTag: 'numune', totalImages: 1 },
  { id: 18, name: 'Sariseki Mahallesi', image: '/assets/images/mahalleler/sariseki/1.jpg', urlTag: 'sariseki', totalImages: 1 },
  { id: 19, name: 'Süleymaniye Mahallesi', image: '/assets/images/mahalleler/suleymaniye/1.jpg', urlTag: 'suleymaniye', totalImages: 1 },
  { id: 20, name: 'Çay Mahallesi', image: '/assets/images/mahalleler/cay/1.jpg', urlTag: 'cay', totalImages: 1 }
];

const getImageUrl = (url) => {
  if (!url) return '/assets/images/default-image.jpg';
  if (url.startsWith('http')) return url;

  if (url.startsWith('/assets/')) return `https://iskenderun.bel.tr${url}`;

  if (url.startsWith('/uploads/')) {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://api.iskenderun.bel.tr/api';
    const apiDomain = apiUrl.endsWith('/api') ? apiUrl.slice(0, -4) : apiUrl;
    return `${apiDomain}${url}`;
  }

  return `https://iskenderun.bel.tr${url.startsWith('/') ? url : `/${url}`}`;
};

const Mahalleler = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getNeighborhoodDevelopments();
        if (response?.isSuccess && Array.isArray(response.data) && response.data.length > 0) {
          setData(response.data);
        } else {
          setData(fallbackMahalleler);
        }
      } catch (err) {
        console.error('Veri çekilemedi, varsayılan liste yükleniyor.', err);
        setData(fallbackMahalleler);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const visibleData = data.length > 0 ? data : fallbackMahalleler;

  const summary = useMemo(() => {
    return {
      totalNeighborhoods: visibleData.length,
      totalImages: visibleData.reduce((sum, item) => sum + (item.totalImages || 0), 0)
    };
  }, [visibleData]);

  return (
    <div className="mahalleler-page">
      <div className="container lg-py-5">
        <div className="col-md-12">
          <section className="mahalle-hero">
            <div className="mahalle-hero__content">
              <span className="mahalle-hero__eyebrow">Sahadan Güncel Çalışmalar</span>
              <h1 className="page-title">Mahallem Gelişiyor</h1>
              <p className="mahalle-hero__description">
                İskenderun’un farklı mahallelerinde yürütülen dönüşüm, bakım ve iyileştirme çalışmalarını sokak bazlı görsel arşivlerle takip edin.
              </p>
            </div>

            <div className="mahalle-hero__stats">
              <div className="hero-stat-card">
                <span className="hero-stat-card__label">Toplam Mahalle</span>
                <strong className="hero-stat-card__value">{summary.totalNeighborhoods}</strong>
              </div>
              <div className="hero-stat-card">
                <span className="hero-stat-card__label">Toplam Görsel</span>
                <strong className="hero-stat-card__value">{summary.totalImages}</strong>
              </div>
            </div>
          </section>

          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <div className="spinner-border text-primary" role="status"></div>
            </div>
          ) : (
            <div className="row g-4">
              {visibleData.map((mahalle, index) => (
                <div key={mahalle.guid || mahalle.id || index} className="col-md-6 col-xl-4">
                  <Link to={`/mahalleler/${mahalle.urlTag}`} className="mahalle-card">
                    <div className="mahalle-card-image">
                      <img src={getImageUrl(mahalle.coverImage || mahalle.image)} alt={mahalle.name} />
                      <div className="mahalle-card-badge">
                        <FaImages />
                        <span>{mahalle.totalImages || 0} fotoğraf</span>
                      </div>
                    </div>
                    <div className="mahalle-card-content">
                      <span className="mahalle-card-kicker">
                        <FaLayerGroup />
                        Mahalle Arşivi
                      </span>
                      <h3>{mahalle.name}</h3>
                      <div className="mahalle-card-footer">
                        <span>Detaya Git</span>
                        <FaArrowRight />
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Mahalleler;
